<div class="registration-layout login-banner">
  <img alt="imagedetails" [src]="'logos/logowhite.png' | contentAssetImage" class="logo" />
  <div class="registration-container">
    <router-outlet></router-outlet>
  </div>
</div>
